import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';

// ── Composant double saisie Min / Max ─────────────────────────────────────────

function NumericRangeInput({ item, applyValue, focusElementRef }) {
    const parts   = (item.value ?? '').split('§');
    const minVal  = parts[0] ?? '';
    const maxVal  = parts[1] ?? '';

    const apply = (min, max) => applyValue({ ...item, value: `${min}§${max}` });

    return (
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-end', py: 0.5 }}>
            <TextField
                label="Min"
                type="number"
                variant="standard"
                size="small"
                value={minVal}
                inputRef={focusElementRef}
                onChange={e => apply(e.target.value, maxVal)}
                sx={{ width: 80 }}
                slotProps={{ htmlInput: { style: { fontSize: '0.82rem' } } }}
            />
            <TextField
                label="Max"
                type="number"
                variant="standard"
                size="small"
                value={maxVal}
                onChange={e => apply(minVal, e.target.value)}
                sx={{ width: 80 }}
                slotProps={{ htmlInput: { style: { fontSize: '0.82rem' } } }}
            />
        </Box>
    );
}

// ── Opérateur "entre" ─────────────────────────────────────────────────────────

export const numericRangeOperator = {
    label: 'entre',
    value: 'between',
    getApplyFilterFn(filterItem) {
        if (!filterItem.value) return null;
        const [minStr, maxStr] = filterItem.value.split('§');
        const min = minStr !== '' && minStr !== undefined ? Number(minStr) : null;
        const max = maxStr !== '' && maxStr !== undefined ? Number(maxStr) : null;
        if (min === null && max === null) return null;
        return (value) => {
            // Exclure les cellules sans valeur
            if (value === null || value === undefined) return false;
            const num = Number(value);
            if (isNaN(num)) return false;
            if (min !== null && num < min) return false;
            if (max !== null && num > max) return false;
            return true;
        };
    },
    InputComponent: NumericRangeInput,
};

